<nb-card>
  <nb-card-header>
    <div class="summary">
      <div class="item">
        <div class="avatar">
          <ngx-view-user-display
            [imageURL]="
              person.coverUrl
                ? person.coverUrl
                : '/assets/images/default_avatar.jpg'
            "
            [mode]="'avatar'"
            (onClick)="edit(person)"
          ></ngx-view-user-display>
        </div>

        <div>
          <a
            *ngIf="person?.fullName"
            class="text-body link"
            (onClick)="loadContent(true)"
          >
            <h6>{{ person.fullName }}</h6>
          </a>

          <div *ngIf="person.tags?.length > 0" class="text-link">
            <ngx-view-tags
              [tags]="person.tags"
              (onTagSelected)="tagSelected($event)"
            ></ngx-view-tags>
          </div>
        </div>
      </div>
    </div>

    <div class="button-action">
      <button
        nbButton
        ghost
        shape="round"
        status="primary"
        size="small"
        class="action-button"
        [disabled]="loading"
        [class.btn-pulse]="loading"
        [nbContextMenu]="menuItems"
        [nbContextMenuTag]="'action-buttons-' + person.id"
        (click)="loadButtonAction(person)"
      >
        <nb-icon icon="more-horizontal-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>

  <nb-card-body>
    <div class="content">
      <a
        *ngIf="person?.mobile"
        href="tel:{{ person.mobile }}"
        class="text-primary link"
      >
        <nb-icon icon="phone-call-outline"></nb-icon> {{ person.mobile }}
      </a>

      <a
        *ngIf="person?.email"
        href="mailto:{{ person.email }}"
        class="text-primary link"
      >
        <nb-icon icon="email-outline"></nb-icon> {{ person.email }}
      </a>
    </div>

    <a *ngIf="!isMore" (click)="loadContent(true)" class="link text-link">
      <nb-icon icon="chevron-down-outline"></nb-icon>
      Mở rộng
    </a>

    <nb-card *ngIf="isMore">
      <nb-card-body>
        <ul class="detail">
          <li *ngIf="person.gender">
            {{ "common.gender" | translate }}:
            <span class="text-hint"> {{ person.gender }}</span>
          </li>
          <li *ngIf="person.dob">
            {{ "person.dob" | translate }}:
            <span class="text-hint">
              {{ person.dob | date: "dd/MM/yyyy" }}</span
            >
          </li>
          <li *ngIf="person.cardId">
            CMND: <span class="text-hint"> {{ person.cardId }}</span>
          </li>
          <li *ngIf="person.tax">
            {{ "person.tax" | translate }}:
            <span class="text-hint"> {{ person.tax }}</span>
          </li>
          <li *ngIf="person.address">
            {{ "common.address" | translate }}:<span class="text-hint">
              {{ person.address }}
            </span>
          </li>
          <li *ngIf="person.description">
            {{ "common.note" | translate }}:
            <span class="text-hint" style="white-space: pre">{{
              person.description
            }}</span>
          </li>
          <li *ngIf="person.customerId">
            Khách hàng:
            <span class="text-hint">{{ person.customerName }}</span>
          </li>
          <li *ngIf="person.supplierId">
            Nhà cung cấp:
            <span class="text-hint">{{ person.supplierName }}</span>
          </li>
          <li *ngIf="person.employeeId">
            Nhân viên:
            <span class="text-hint">{{ person.employeeName }}</span>
          </li>
        </ul>
        <ngx-view-gallery
          *ngIf="person.imagesUrl?.length > 0"
          [imagesUrl]="person.imagesUrl"
        >
        </ngx-view-gallery>
      </nb-card-body>
    </nb-card>
    <div class="content">
      <a *ngIf="isMore" (click)="loadContent(false)" class="link text-link">
        <nb-icon icon="chevron-up-outline"></nb-icon>
      </a>

      <div *ngIf="isMore" class="button-action">
        <button
          nbButton
          ghost
          status="danger"
          size="small"
          [disabled]="submitted"
          [class.btn-pulse]="submitted"
          (click)="delete(person)"
        >
          <nb-icon icon="trash-2-outline"></nb-icon>
        </button>

        <button
          nbButton
          ghost
          status="info"
          size="small"
          [disabled]="submitted"
          [class.btn-pulse]="submitted"
          (click)="edit(person)"
        >
          <nb-icon icon="edit-2-outline"></nb-icon>
        </button>
      </div>
    </div>
  </nb-card-body>

  <!-- <nb-card-footer>
    <div class="button-actions">
      <button
        *ngIf="mode != 'person'"
        nbButton
        ghost
        status="success"
        size="small"
        [disabled]="submitted"
        [class.btn-pulse]="submitted"
        (click)="createHistory(person)"
      >
        <nb-icon icon="file-text-outline"></nb-icon>
        <span *ngIf="!isMobile"> Tạo nhật ký</span>
        <span *ngIf="isMobile"> Nhật ký</span>
      </button>

      <button
        *ngIf="mode != 'person'"
        nbButton
        ghost
        size="small"
        status="info"
        [disabled]="submitted"
        [class.btn-pulse]="submitted"
        (click)="viewHistory(person)"
      >
        <nb-icon icon="calendar-outline"></nb-icon>
        <span *ngIf="!isMobile"> Xem lịch sử</span>
        <span *ngIf="isMobile"> Lịch sử</span>
      </button>
    </div>
  </nb-card-footer> -->
</nb-card>
